/**
 * Centered-track layout for a diverging stacked rating.
 *
 * Lifted from Quick Study (`apps/frontend/src/components/quick-study-results/divergingStacked.ts`).
 * Quick Study is not migrated onto this module; a frontend parity test is the drift guard.
 *
 * R4.1 / crafted-exhibits Step 1: merge of this fork into the shared aggregation
 * lib is explicitly deferred.
 */
import { DivergingRow } from './divergingRowFromDistribution'

// A TRUE diverging layout (same geometry as the matrix diverging bar): every row
// shares a fixed zero line at the track centre (50%). The full track spans the
// −100%…+100% range, so a respondent share s renders as s/2 container-%; the left
// spacer lands the neutral band's midpoint (or the low|high boundary for even
// scales, where neutral = 0) exactly on the centre line.
export interface DivergingLayout {
  spacerPct: number
  lowPct: number
  neutralPct: number
  highPct: number
}

export function divergingLayout(row: Pick<DivergingRow, 'n' | 'low' | 'neutral' | 'high'>): DivergingLayout {
  const n = row.n || 1
  const fl = row.low / n
  const fnu = row.neutral / n
  const fh = row.high / n
  return {
    spacerPct: (0.5 - fl / 2 - fnu / 4) * 100,
    lowPct: (fl / 2) * 100,
    neutralPct: (fnu / 2) * 100,
    highPct: (fh / 2) * 100,
  }
}
